import { ScreenSizes } from '../../classes/screen-sizes.class';
import { GalleryItem } from '../classes/gallery-item.class';

export const getAssetSectionHeight = (items: GalleryItem[], spacing: number) => {
  if (!items.length) return 0;
  if (ScreenSizes.screenSize() === 'mobile') spacing /= 2;
  return items.reduce((r, item) => Math.max(item.bounds.y + item.bounds.height, r), 0) + spacing;
};
